<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
        <rect class="st0 svg-secondary-color" style="opacity:0;" width="24" height="24"/>
        <path id="Path_7915" class="st1 svg-secondary-color" d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2C12,2,12,2,12,2 M17,15.6
	L15.6,17L12,13.4L8.4,17L7,15.6l3.6-3.6L7,8.4L8.4,7l3.6,3.6L15.6,7L17,8.4L13.4,12L17,15.6z"/>
    </svg>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
        name: "IconExpandColumn",
        computed: {
            ...mapGetters({
                // getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/IconClear.vue